import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min";

import PatientReferralForm from "./pages/PatientReferralForm";
import PatientReferralManagement from "./pages/PatientReferralManagement";
import SiteMap from "./pages/Sitemap";
import SignIn from "./comp/SignIn";
import TemplateCustomizer from "./pages/TemplateCustomizer";
import ProtectedRoute from "./comp/ProtectedRoute";
import PracticeReferralForm from "./pages/PracticeReferralForm";


function App() {

    return (
    <BrowserRouter>
        <Routes>
            <Route path="/patient-referral" element={<PatientReferralForm/>} />
            <Route path="/referral/:practiceSlug" element={<PracticeReferralForm/>} />
            <Route path='/data' element={<ProtectedRoute><PatientReferralManagement/></ProtectedRoute>}/>
            <Route path='/sign-in' element={<SignIn/>}/>
            <Route path='/customize-template' element={<ProtectedRoute><TemplateCustomizer/></ProtectedRoute>}/>
            <Route path='*' element={<Navigate to='/patient-referral' replace />}/>
        </Routes>
    </BrowserRouter>
    );
}

export default App;